import React from 'react'
import { ArrowDown, Sparkles, MapPin, Code2, Lightbulb } from 'lucide-react'

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center hero-gradient overflow-hidden">
      {/* 背景装饰 */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-accent-300 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-primary-300 rounded-full blur-3xl"></div>
      </div>

      <div className="container-custom relative z-10">
        <div className="text-center text-white">
          {/* 主标题 */}
          <div className="mb-8 animate-fade-in">
            <h1 className="text-5xl md:text-7xl font-bold mb-4 text-balance">
              Jordan <span className="text-accent-300">乔丹</span>
            </h1>
            <div className="flex flex-wrap justify-center items-center gap-4 text-lg md:text-xl mb-6">
              <div className="flex items-center gap-2">
                <Code2 size={24} />
                <span>AI全栈工程师</span>
              </div>
              <div className="hidden md:block w-1 h-1 bg-white rounded-full"></div>
              <div className="flex items-center gap-2">
                <MapPin size={24} />
                <span>世界探索者</span>
              </div>
              <div className="hidden md:block w-1 h-1 bg-white rounded-full"></div>
              <div className="flex items-center gap-2">
                <Lightbulb size={24} />
                <span>创业者</span>
              </div>
              <div className="hidden md:block w-1 h-1 bg-white rounded-full"></div>
              <div className="flex items-center gap-2">
                <Sparkles size={24} />
                <span>学习新范式倡导者</span>
              </div>
            </div>
          </div>

          {/* 描述 */}
          <div className="mb-12 animate-fade-in animation-delay-200">
            <p className="text-xl md:text-2xl mb-6 text-white/90 max-w-4xl mx-auto text-balance">
              从985大学到海外名校交流访问，从算法工程师到AI时代探索者和创业者
            </p>
            <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto text-balance">
              裸辞后的自驾中国、环球旅行、南北极探险，积极参与创业实践，用技术连接世界，用代码改变生活
            </p>
          </div>

          {/* 统计数据 */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12 animate-fade-in animation-delay-400">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-accent-300 mb-2">4+</div>
              <div className="text-sm md:text-base text-white/80">国际名校学术交流访问</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-accent-300 mb-2">30+</div>
              <div className="text-sm md:text-base text-white/80">国家和地区</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-accent-300 mb-2">3</div>
              <div className="text-sm md:text-base text-white/80">黑客松项目</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-accent-300 mb-2">∞</div>
              <div className="text-sm md:text-base text-white/80">探索精神</div>
            </div>
          </div>

          {/* CTA按钮 */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in animation-delay-600">
            <a
              href="#about"
              className="btn-primary px-8 py-4 text-lg bg-white text-primary-900 hover:bg-gray-100 hover:scale-105 transform transition-all duration-300"
            >
              了解我的故事
            </a>
            <a
              href="#projects"
              className="btn-primary px-8 py-4 text-lg bg-white text-primary-900 hover:bg-gray-100 hover:scale-105 transform transition-all duration-300"
            >
              查看我的项目
            </a>
          </div>
        </div>
      </div>

      {/* 滚动指示器 */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ArrowDown className="text-white/60" size={24} />
      </div>
    </section>
  )
}

export default Hero 